import styled from 'styled-components';
export const CaptureDocumentWrapper = styled.div `
  .csl-box {
    padding: 0;
  }
  .csl-confirmation__input {
    padding: 10px;
  }
`;
export const CapturePhotoImageWrapper = styled.div `
  width: 100% !important;
  height: auto;

  img {
    width: 100% !important;
  }
`;
//# sourceMappingURL=styles.js.map